import { CountryData, defaultCountries, getActiveFormattingMask, getCountry, parseCountry } from 'react-international-phone';
import { AuthPhoneValue, EMPTY_AUTH_PHONE } from 'types/auth';

export const getDialCodeForIso = (iso?: string | null): string => {
    if (!iso) return EMPTY_AUTH_PHONE.country_code;
    const country = getCountry({ field: 'iso2', value: iso.toLowerCase() });
    return country?.dialCode ?? EMPTY_AUTH_PHONE.country_code;
};

export const getCountriesForIso = (iso?: string | null): CountryData[] => {
    const code = (iso || EMPTY_AUTH_PHONE.country).toLowerCase();
    const filtered = defaultCountries.filter((country) => parseCountry(country).iso2 === code);
    if (filtered.length) return filtered;
    return defaultCountries.filter(
        (country) => parseCountry(country).iso2 === EMPTY_AUTH_PHONE.country.toLowerCase()
    );
};

export const emptyAuthPhoneForIso = (iso?: string | null): AuthPhoneValue => {
    const country = parseCountry(getCountriesForIso(iso)[0]);
    return {
        country: country.iso2.toUpperCase(),
        country_code: country.dialCode,
        mobile: '',
    };
};

export const parseAuthPhone = (
    phone: string,
    iso2: string,
    dialCode: string
): AuthPhoneValue => {
    const country_code = dialCode;
    const e164Prefix = `+${dialCode}`;
    const mobile = phone.startsWith(e164Prefix) ? phone.slice(e164Prefix.length) : '';

    return {
        country: iso2.toUpperCase(),
        country_code,
        mobile,
    };
};

export const toE164 = (value: AuthPhoneValue): string =>
    `+${value.country_code}${value.mobile}`;

export const toInternationalDigits = (value: AuthPhoneValue): string =>
    `${value.country_code}${value.mobile.trim()}`;

export const isValidAuthPhone = (value: AuthPhoneValue): boolean => {
    if (!value.country || !value.country_code || !value.mobile) return false;
    if (!/^\d+$/.test(value.mobile)) return false;

    const country = getCountry({ field: 'iso2', value: value.country.toLowerCase() });
    if (!country) return false;

    if (!country.format) {
        const maxNational = 15 - value.country_code.length;
        return value.mobile.length >= 6 && value.mobile.length <= maxNational;
    }

    const mask = getActiveFormattingMask({ phone: toE164(value), country });
    const expectedDigits = (mask.match(/\./g) || []).length;

    if (!expectedDigits) {
        return value.mobile.length >= 6 && value.mobile.length <= 12;
    }

    return value.mobile.length === expectedDigits;
};
